import { useCoachMark } from '#hooks/useCoachMark';
import { PropsWithChildren, useEffect } from 'react';
import CoachMarkSpotLight from './SpotLight';
import CoachMarkTooltip from './Tooltip';

interface CoachMarkProps extends PropsWithChildren {}

const CoachMarkMain = ({ children }: CoachMarkProps) => {
  const { isCoachMark, setCoachMark } = useCoachMark();

  // 스크롤 이벤트를 막는 함수
  const preventScroll = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  // 마우스 휠 스크롤 막기
  const preventWheel = (e: any) => {
    e.preventDefault();
  };

  useEffect(() => {
    const body = document.querySelector('body');

    if (isCoachMark) {
      body?.classList.add('overflow-hidden');

      // 스크롤 이벤트 막기
      window.addEventListener('scroll', preventScroll, { passive: false });

      // 마우스 휠 이벤트 막기
      window.addEventListener('wheel', preventWheel, { passive: false });
    } else {
      body?.classList.remove('overflow-hidden');

      // 스크롤 이벤트 허용
      window.removeEventListener('scroll', preventScroll);
      // 마우스 휠 이벤트 허용
      window.removeEventListener('wheel', preventWheel);
    }

    return () => {
      body?.classList.remove('overflow-hidden');

      window.removeEventListener('scroll', preventScroll);
      // 마우스 휠 이벤트 허용
      window.removeEventListener('wheel', preventWheel);
    };
  }, [isCoachMark]);

  if (!isCoachMark) return null;

  return (
    <div
      onClick={() => setCoachMark(false)}
      className="fixed left-0 top-0 w-full h-[100dvh] z-30"
    >
      <div className="w-full h-full flex flex-col items-center opacity-80 bg-[#3e3d42] backdrop-blur-2xl">
        {children}
      </div>
    </div>
  );
};

const CoachMark = Object.assign(CoachMarkMain, {
  SpotLight: CoachMarkSpotLight,
  Tooltip: CoachMarkTooltip
});

export default CoachMark;
